<template>
  <div>
    <com-dialog :title="typeTitle[type]" width="50%" :visible.sync="visible">
      <div>
        <el-form :model="formData" label-width="100px">
          <el-form-item label="消息名称">
            <el-input
              v-model="formData.title"
              placeholder="请输入"
              :disabled="type === 'detail'"
            ></el-input>
          </el-form-item>
          <el-form-item label="接收方">
            <el-checkbox-group v-model="formData.types">
              <el-checkbox
                label="ALL"
                :disabled="(!checkboxDisabled && formData.types.length >= 1) || type === 'detail'"
                >全部</el-checkbox
              >
              <el-checkbox label="USER" :disabled="checkboxDisabled || type === 'detail'"
                >普通用户</el-checkbox
              >
              <el-checkbox label="BUSINESS" :disabled="checkboxDisabled || type === 'detail'"
                >商家</el-checkbox
              >
              <el-checkbox label="PARTNER" :disabled="checkboxDisabled || type === 'detail'"
                >合伙人</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <timynce
              :value="formData.content"
              @listenChangeEditorValue="handleContent"
              :disabled="type === 'detail'"
            ></timynce>
          </el-form-item>
          <el-form-item>
            <div class="flex justify-end">
              <el-button type="" @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm" :disabled="type === 'detail'"
                >确定</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import timynce from '@/components/tinymce'
import { addSystemNotify, systemNoticeDetail, systemNoticeUpdate } from '@/api/notify'
import utils from 'my-tools-library'

export default {
  components: { timynce },
  data() {
    return {
      visible: false,
      type: 'created',
      typeTitle: {
        created: '新建消息',
        edit: '编辑消息',
        detail: '详情'
      },
      formData: {
        types: [],
        title: '',
        content: ''
      },
      checkboxDisabled: false
    }
  },
  methods: {
    // 获取详情
    async getDetail(code) {
      const res = await systemNoticeDetail({ code })
      if (res) {
        const { managerSystemNotice } = res.data
        this.formData = utils.deepCopy(managerSystemNotice)
        this.formData.types = managerSystemNotice.type.split(',')
      }
    },
    open(row) {
      const { type, code } = row
      this.type = type
      if (type === 'created') this.formData = { types: [], title: '', content: '' }
      if (code) this.getDetail(code)
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.formData = {}
      }, 10)
    },
    handleContent(val) {
      this.formData.content = val
    },
    // 新增
    async handleAdd() {
      const res = await addSystemNotify(this.formData)
      console.log('res :>> ', res)
      if (res) {
        this.$message.success('操作成功')
        this.$emit('onSuccess')
        this.close()
      }
    },
    // 编辑
    async handleEdit() {
      const res = await systemNoticeUpdate(this.formData)
      if (res) {
        this.$message.success('操作成功')
        this.$emit('onSuccess')
        this.close()
      }
    },
    handleConfirm() {
      if (this.type === 'created') {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    }
  },
  watch: {
    formData: {
      handler(val) {
        if (val.types.indexOf('ALL') !== -1) {
          this.checkboxDisabled = true
        } else {
          this.checkboxDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
